import React, { useRef, useState } from "react";
import { toast } from "react-toastify";
import close from "../assets/cancel.svg";
import cart from "../assets/cart.svg";
import LazyLoading from "../components/Orders/LazyLoading";
import { amountFormat, getAccessLevel } from "../config/helper";

const Table = (props) => {
  const { setQuantityObj, quantityObj, lineItems, scroll, data, totalRecords } =
    props;
  const [isLeft, setIsLeft] = useState(true);
  let selectedItems =
    quantityObj &&
    Object.keys(quantityObj)?.filter(
      (ele) =>
        !ele.includes("prod_id") &&
        !lineItems?.find(
          (itm) => itm.SKU === ele && quantityObj[ele] === itm.Quantity
        ) &&
        quantityObj[ele]
    );
  const getRight = (len, index) => {
    if (len === index) {
      return 0;
    } else return props.columns[index + 1].width;
  };

  const scrollableContainerRef = useRef(null);
  const permissions = JSON.parse(localStorage.getItem("permissions") || "{}");
  const access = getAccessLevel("new_order");
  const isViewOnly = access === "view_only";


  const handleScroll = () => {
    const container = scrollableContainerRef.current;

    if (container) {
      const isAtEnd =
        parseInt(container.scrollLeft + container.clientWidth) ===
        container.scrollWidth;
      console.log(
        isAtEnd,
        container.scrollLeft,
        container.clientWidth,
        container.scrollWidth
      );
      if (isAtEnd) {
        setIsLeft(false);
      } else {
        setIsLeft(true);
      }
    }
  };

  return (
    <>
      <div
        className={props.noMargin ? "" : "m2"}
        style={
          props.style
            ? {
                overflowX: "auto",
                ...props.style,
              }
            : {
                overflowX: "auto",
              }
        }
        ref={scrollableContainerRef}
        onScroll={handleScroll}
      >
        <div
          className="table"
          id="table"
          style={scroll?.x ? { width: scroll?.x } : undefined}
        >
          {/* <div className="t-wrap"> */}
          <div className="thead">
            <div className="tr">
              {props.columns?.map((ele, i) => {
                return (
                  ele.header && (
                    <div
                      className={`td ${isLeft && ele.fixed ? "abs" : ""} ${
                        ele.fixed ? "ant-table-cell-fix-" + ele.fixed : ""
                      }`}
                      style={
                        ele.fixed
                          ? {
                              width: ele.width + "%",
                              [ele.fixed]:
                                getRight(props.columns.length - 1, i) + "%",
                            }
                          : { width: ele.width + "%" }
                      }
                    >
                      {ele.header}
                    </div>
                  )
                );
              })}
              {props.action && (
                <div
                  className="action-th"
                  style={{ width: props.actionWidth + "%" }}
                >
                  {props.actionText ? props.actionText : "Action"}
                </div>
              )}
            </div>
          </div>
          <div
            className={`tbody ${props.showTotal ? "last-none" : ""}`}
            style={{
              height: props.virtual ? "350px" : "auto",
              overflowY: "auto",
            }}
          >
            {data && Array.isArray(data) && data.length > 0 ? (
              data?.map((item) => (
                <div
                  className={`tr ${
                    typeof props.onRowClick === "function" ? "clickable" : ""
                  }`}
                  onClick={() => {
                    if (props.onRowClick) {
                      props.onRowClick(item);
                    }
                  }}
                >
                  {props.columns.map((ele, i) => {
                    return (
                      ele?.accessor && (
                        <div
                          className={`td ${
                            ele.className ? ele.className : ""
                          } ${props.isCancel ? "flex-between" : ""} ${
                            isLeft && ele.fixed ? "abs" : ""
                          } ${
                            ele.fixed ? "ant-table-cell-fix-" + ele.fixed : ""
                          }`}
                          style={
                            ele.fixed
                              ? {
                                  width: ele.width + "%",
                                  [ele.fixed]:
                                    getRight(props.columns.length - 1, i) + "%",
                                }
                              : { width: ele.width + "%" }
                          }
                        >
                          {ele.cell ? ele.cell(item) : item?.[ele?.accessor]}
                          {props.isCancel && i === props.columns.length - 1 && (
                            <img
                              className="cancel"
                              src={close}
                              alt={"close"}
                              width={14}
                              onClick={() => {
                                props.delete(item.id);
                              }}
                            />
                          )}
                        </div>
                      )
                    );
                  })}
                  {props.action && (
                    <>
                      <div
                        className="td action-td"
                        style={{ width: props.actionWidth + "%" }}
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                      >
                        <input
                          disabled={isViewOnly}
                          className={
                            (props.fromCart &&
                              quantityObj[item.sku] > 0 &&
                              lineItems?.find((ele) => ele.SKU === item.sku)
                                ?.id) ||
                            (props.fromOrder &&
                              item.quantity > 0 &&
                              lineItems.find((ele) => ele.id === item.id)?.id)
                              ? "cart-input"
                              : ""
                          }
                          value={
                            quantityObj[item.sku] ? quantityObj[item.sku] : ""
                          }
                          // value={quantityObj[item.sku] || item.quantity ? quantityObj[item.sku] || item.quantity : ""}
                          onChange={(e) => {
                            if (!Number.isNaN(Number(e.target.value))) {
                              setQuantityObj({
                                ...quantityObj,
                                [item.sku]: parseInt(e.target.value),
                                [`${item.sku}_prod_id`]: item.id,
                              });
                              if (props.fromOrder) {
                                item.quantity = parseInt(e.target.value);
                                // props.addToCart(item);
                              }
                            }
                          }}
                        />

                        <button
                          // className={
                          //   (props.fromCart &&
                          //     quantityObj[item.sku] > 0 &&
                          //     lineItems?.find((ele) => ele.SKU === item.sku)?.id)
                          //     // ||
                          //     // (props.fromOrder &&
                          //     //   item.quantity > 0 &&
                          //     //   // quantityObj[item.sku] > 0 &&
                          //     //   lineItems.find((ele) => ele.id === item.id)?.id)
                          //     ? "bg-green"
                          //     : ""
                          // }
                         disabled={
                            isViewOnly ||
                            (props.showMulti &&
                              selectedItems?.length > 1 &&
                              !props.fromOrder) ||
                            parseFloat(item.unit_price ? item.unit_price : 0) <=
                              0
                          }
                          onClick={() => {
                            if (quantityObj[item.sku] > 0) {
                              props.addToCart(item);
                            } else {
                              toast.error("Please add some quantity.");
                            }
                          }}
                        >
                          <img src={cart} alt="cart" />
                        </button>
                        {props.fromCart &&
                          !props.fromOrder &&
                          quantityObj[item.sku] > 0 && (
                            <img
                              className="cancel mlHalf"
                              src={close}
                              alt={"close"}
                              width={14}
                              onClick={() =>
                                props.delete(
                                  lineItems?.find((ele) => 
                                    (ele.SKU === item._originalSku || ele.SKU === item.sku) && 
                                    String(ele.product_id) === String(item.id || item._productIndex)
                                  )?.id
                                )
                              }
                              style={{
                                position: "absolute",
                                right: "2px",
                              }}
                            />
                          )}
                      </div>
                    </>
                  )}
                </div>
              ))
            ) : props.loading ? null : (
              <div className="no-data">No Records Found</div>
            )}

            <LazyLoading
              loading={props.loading}
              totalRecords={totalRecords}
              isLastPage={props.isLastPage}
              onPagination={props.onPagination}
              data={data}
            />

            {props.orderEdit && (
              <div className="tr">
                {props.columns.map((ele, i) => {
                  return (
                    <div
                      className={`td ${ele.className ? ele.className : ""} ${
                        props.isCancel ? "flex-between" : ""
                      }`}
                      // style={{ width: ele.width + "%" }}
                    >
                      {i === 0 ? (
                        <button
                          onClick={props.orderEditAction}
                          style={{
                            border: "1px solid #ececec",
                            padding: "0.7rem 1rem",
                            borderRadius: 4,
                            fontWeight: 600,
                          }}
                        >
                          Add Products
                        </button>
                      ) : null}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
          {/* </div> */}
          {/* {props.action && (
        <div className="action-div">
          <div className="action-th" style={{ width: "8rem" }}>
            Action
          </div>
          {data?.map((item) => (
            <div className="action-td" style={{ width: "8rem" }}>
              <input />
              <button>
                <img src={cart} alt="cart" />
              </button>
            </div>
          ))}
        </div>
      )} */}
          {props.showTotal && (
            <div className="total m1">
              <div className="w45 d-flex mt1">
                <div className="w40">
                  <span className="dim-text">
                    {props?.totalQtyText ?? "Total Quantity"} :{" "}
                    {props?.totalQuantity} pcs
                  </span>
                  <br />
                  <span className="dim-text">
                    Total Fill : {props.totalFill}
                  </span>
                </div>
                <div className="w60">
                  <span className="flex-between ml2 mr2">
                    <span className="dim-text">Sub Total :</span>
                    <span> ${amountFormat(props.totalPrice)}</span>
                  </span>
                  <hr />
                  <span className="flex-between ml2 mr2">
                    <span>Total :</span>
                    <span> ${amountFormat(props.totalPrice)}</span>
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {props.showMulti && selectedItems?.length > 1 && !props.fromOrder && (
        <div className="show_multi">
          <span>({selectedItems?.length}) items selected</span>
          <button
            className="primary-btn"
            onClick={() => {
              props.addAllToCart();
            }}
          >
            Add items to cart
          </button>
          <button
            className="cancel-btn"
            onClick={() => {
              setQuantityObj({});
            }}
          >
            Cancel
          </button>
        </div>
      )}
    </>
  );
};

export default Table;
